import styled, {css, keyframes} from "styled-components";
import {LayoutConst} from "../../../core";
import {Colors} from "@brg/ui";

export const FixedAudioPlayerWrapper = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            position: fixed;
            bottom: 40px;
            right: 64px;
            z-index: 199999;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              bottom: 40px;
              right: 64px;
            }

            @media (max-width: ${LayoutConst.screen.l}px) {
              bottom: 55px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              bottom: 55px;
              right: 16px;
            }

            @media (max-width: 834px) {
              bottom: 36px;
            }
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 30px;
              right: 0;
              display: flex;
              width: 100%;
              justify-content: center;
            }
          `
          : css`
            position: fixed;
            bottom: 31px;
            left: 0px;
            z-index: 199999;
            width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              bottom: 31px;
              left: 0px;
            }
            
            @media (max-width: ${LayoutConst.screen.l}px) {
              bottom: 39px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              right: 0;
              left: 0;
              bottom: 39px;
            }

            @media (max-width: 834px) {
              bottom: 28px;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 28px;
            }
          `}
`;

export const AudioPlayerExtraSpace = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              padding: 24px;
            }
          `
          : css`

          `}
`;

export const AudioPlayerWrapper = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            background: ${Colors.galBlack5};
            padding: 10px 28px;
            display: flex;
            align-items: center;
            column-gap: 16px;
            border-radius: 3px;

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: 240px;
              height: 40px;
              padding: 8px 16px;
            }

            @media (max-width: 834px) {
              bottom: 36px;
            }
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 36px;
              right: 10px;
              width: fit-content;
              max-width: calc(100vw - 20px);
              height: 36px;
              padding: 6px 12px;
              background: ${Colors.geoWhite100};
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
            }
          `
          : css`
            width: 100%;
            background: ${Colors.galBlack5};
            height: 57px;
            display: flex;
            justify-content: center;
            align-items: center;

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: 100vw;
              height: 98px;
              display: flex;
              justify-content: center;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              height: 94px;
            }
          `}
`;

export const AudioPlayerWrapperHidden = styled.div`
  position: fixed;
  bottom: 40px;
  right: 64px;
  z-index: 100;
  background: ${Colors.galBlack5};
  width: 228px;
  height: 40px;
  padding: 10px 28px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  border-radius: 3px;
`;

export const CloseAudioIconWrapper = styled.div`
  position: absolute;
  cursor: pointer;
  right: 16px;
  top: 12px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 8px;
  }

  svg {
    path {
      fill: ${Colors.galBlack47}
    }
  }
`

export const AudioPlayerBody = styled.div<{isHidden?: boolean}>`

  ${({isHidden}) => !isHidden && css`
            display: flex;
            width: 1152px;
            column-gap: 24px;
            align-items: center;
            height: 42px;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 888px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: calc(100vw - 32px);
              flex-direction: column-reverse;
              height: 98px;
              align-items: flex-start;
              row-gap: 12px;
              padding-bottom: 8px;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              height: 94px;
              row-gap: 8px;
            }

            &::-webkit-scrollbar {
              height: 0px;
              width: 0px;
            }
            &::-webkit-scrollbar-track {
              border-radius: 10px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
            }
          `}
`

export const SpeedComponentWrapper = styled.div<{hidden?: boolean}>`
  display: flex;
  flex-direction: column;
  color: ${Colors.galBlack47};
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
  height: 24px;
  width: 28px;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  
  ${({hidden}) => hidden && css`
    display: none;
  `};
`

export const ProgressLineWrapper = styled.div`
  position: relative;
  width: 100%;
  background: ${Colors.galBlack21};
  border-radius: 5px;
  height: 4px; 
  cursor: pointer;
`

export const ProgressLine = styled.input<{progressBarPercent?: number}>`

  -webkit-appearance: none;
  width: 100%;
  top: -14px;
  height: 4px;
  background: transparent;
  position: relative;
  z-index: 2;
  border-radius: 5px;
  cursor: pointer;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 8px; /* Ширина зелёного квадрата */
    height: 8px; /* Высота зелёного квадрата */
    background: ${Colors.galBlack47}; /* Цвет зелёного квадрата */
    cursor: pointer;
    position: relative;
    z-index: 3;
    border-radius: 100%;
  }

  ::-moz-range-thumb {
    width: 25px;
    height: 4px;
    background: #4CAF50;
    cursor: pointer;
  }

  ::-moz-range-track {
    height: 4px;
    background: ${Colors.galBlack47};
  }

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: ${Colors.galBlack47}; 
    width: ${({progressBarPercent}) => (progressBarPercent || 0) + '%'};
    z-index: 1;
  }
`

export const AudioTime = styled.div`
  color: ${Colors.galBlack47};
  font-size: 11px;
  font-weight: 400;
  line-height: 11px;
`

const audioTitleMarquee = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 1;
  }
  85% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 1;
  }
  92% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 0;
  }
  93% {
    transform: translateX(0);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const AudioTitle = styled.div<{isScrolling?: boolean}>`
  color: ${Colors.galBlack47};
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.02em;

  display: block;
  width: 100%;
  max-width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;

    ${({isScrolling}) => isScrolling && css`
      text-overflow: unset;
    `}
    
    ${({ onClick }) => onClick && css`
        cursor: pointer;
        
        &:hover {
            color: ${Colors.galBlack61};
        }
    `}

    @media (max-width: ${LayoutConst.screen.s}px){
      font-size: 17px;
      line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.sm}px){
      font-size: 14px;
      line-height: 18px;
    }
`

export const AudioTitleText = styled.span<{shouldScroll?: boolean, duration?: number}>`
  display: inline-block;
  transform: translateX(0);
  will-change: transform;
  white-space: nowrap;
  flex: 0 0 auto;
  min-width: max-content;
  width: max-content;
  flex-shrink: 0;
`

export const AudioTitleTrack = styled.div<{shouldScroll?: boolean}>`
  display: inline-flex;
  align-items: center;
  gap: 32px;
  width: max-content;
  flex: 0 0 auto;
  min-width: max-content;

  ${({shouldScroll}) => shouldScroll
          ? css`
            animation: ${audioTitleMarquee} var(--marquee-duration, 12s) linear infinite;
            animation-fill-mode: forwards;
            will-change: transform, opacity;
          `
          : css`
            animation: none;
          `
  };
`

export const IPhoneSwitcherWrapper = styled.div<{active?: boolean}>`
  border-radius: 12.667px;
  background: ${({active}) => active ? '#27AE60' : Colors.galBlack21};
  width: 32px;
  min-width: 32px;
  display: flex;
  height: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  justify-content: ${({active}) => active ? 'flex-end' : 'flex-start'};
  position: relative;

  div {
    transition: all 0.2s ease-in-out;
    position: absolute;
    top: 3px;
    left: ${({active}) => active ? 'calc(100% - 2.6px - 10px)' : '3px'};
    background: ${Colors.galBlack5};
    width: 10px;
    min-width: 10px;
    height: 10px;
    min-height: 10px;
    border-radius: 100%;
  }
`

export const IPhoneSwitcherLabel = styled.div`
  color: ${Colors.galBlack61};
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 
`import styled, {css, keyframes} from "styled-components";
import {LayoutConst} from "../../../core";
import {Colors} from "@brg/ui";

export const FixedAudioPlayerWrapper = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            position: fixed;
            bottom: 40px;
            right: 64px;
            z-index: 199999;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              bottom: 40px;
              right: 64px;
            }

            @media (max-width: ${LayoutConst.screen.l}px) {
              bottom: 55px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              bottom: 55px;
              right: 16px;
            }

            @media (max-width: 834px) {
              bottom: 36px;
            }
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 30px;
              right: 0;
              display: flex;
              width: 100%;
              justify-content: center;
            }
          `
          : css`
            position: fixed;
            bottom: 31px;
            left: 0px;
            z-index: 199999;
            width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              bottom: 31px;
              left: 0px;
            }
            
            @media (max-width: ${LayoutConst.screen.l}px) {
              bottom: 39px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              right: 0;
              left: 0;
              bottom: 39px;
            }

            @media (max-width: 834px) {
              bottom: 28px;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 28px;
            }
          `}
`;

export const AudioPlayerExtraSpace = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              padding: 24px;
            }
          `
          : css`

          `}
`;

export const AudioPlayerWrapper = styled.div<{isHidden?: boolean}>`
  
  ${({isHidden}) => isHidden 
          ? css`
            background: ${Colors.galBlack5};
            padding: 10px 28px;
            display: flex;
            align-items: center;
            column-gap: 16px;
            border-radius: 3px;

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: 240px;
              height: 40px;
              padding: 8px 16px;
            }

            @media (max-width: 834px) {
              bottom: 36px;
            }
            
            @media (max-width: ${LayoutConst.screen.s}px) {
              bottom: 36px;
              right: 10px;
              width: fit-content;
              max-width: calc(100vw - 20px);
              height: 36px;
              padding: 6px 12px;
              background: ${Colors.geoWhite100};
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
            }
          `
          : css`
            width: 100%;
            background: ${Colors.galBlack5};
            height: 57px;
            display: flex;
            justify-content: center;
            align-items: center;

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: 100vw;
              height: 98px;
              display: flex;
              justify-content: center;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              height: 94px;
            }
          `}
`;

export const AudioPlayerWrapperHidden = styled.div`
  position: fixed;
  bottom: 40px;
  right: 64px;
  z-index: 100;
  background: ${Colors.galBlack5};
  width: 228px;
  height: 40px;
  padding: 10px 28px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  border-radius: 3px;
`;

export const CloseAudioIconWrapper = styled.div`
  position: absolute;
  cursor: pointer;
  right: 16px;
  top: 12px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 8px;
  }

  svg {
    path {
      fill: ${Colors.galBlack47}
    }
  }
`

export const AudioPlayerBody = styled.div<{isHidden?: boolean}>`

  ${({isHidden}) => !isHidden && css`
            display: flex;
            width: 1152px;
            column-gap: 24px;
            align-items: center;
            height: 42px;

            @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
              width: 888px;
            }

            @media (max-width: ${LayoutConst.screen.m}px) {
              width: calc(100vw - 32px);
              flex-direction: column-reverse;
              height: 98px;
              align-items: flex-start;
              row-gap: 12px;
              padding-bottom: 8px;
            }

            @media (max-width: ${LayoutConst.screen.s}px) {
              height: 94px;
              row-gap: 8px;
            }

            &::-webkit-scrollbar {
              height: 0px;
              width: 0px;
            }
            &::-webkit-scrollbar-track {
              border-radius: 10px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
            }
          `}
`

export const SpeedComponentWrapper = styled.div<{hidden?: boolean}>`
  display: flex;
  flex-direction: column;
  color: ${Colors.galBlack47};
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
  height: 24px;
  width: 28px;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  
  ${({hidden}) => hidden && css`
    display: none;
  `};
`

export const ProgressLineWrapper = styled.div`
  position: relative;
  width: 100%;
  background: ${Colors.galBlack21};
  border-radius: 5px;
  height: 4px; 
  cursor: pointer;
`

export const ProgressLine = styled.input<{progressBarPercent?: number}>`

  -webkit-appearance: none;
  width: 100%;
  top: -14px;
  height: 4px;
  background: transparent;
  position: relative;
  z-index: 2;
  border-radius: 5px;
  cursor: pointer;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 8px; /* Ширина зелёного квадрата */
    height: 8px; /* Высота зелёного квадрата */
    background: ${Colors.galBlack47}; /* Цвет зелёного квадрата */
    cursor: pointer;
    position: relative;
    z-index: 3;
    border-radius: 100%;
  }

  ::-moz-range-thumb {
    width: 25px;
    height: 4px;
    background: #4CAF50;
    cursor: pointer;
  }

  ::-moz-range-track {
    height: 4px;
    background: ${Colors.galBlack47};
  }

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: ${Colors.galBlack47}; 
    width: ${({progressBarPercent}) => (progressBarPercent || 0) + '%'};
    z-index: 1;
  }
`

export const AudioTime = styled.div`
  color: ${Colors.galBlack47};
  font-size: 11px;
  font-weight: 400;
  line-height: 11px;
`

const audioTitleMarquee = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 1;
  }
  85% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 1;
  }
  92% {
    transform: translateX(calc(-1 * var(--marquee-translate, 0px)));
    opacity: 0;
  }
  93% {
    transform: translateX(0);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const AudioTitle = styled.div<{isScrolling?: boolean}>`
  color: ${Colors.galBlack47};
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.02em;

  display: block;
  width: 100%;
  max-width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;

    ${({isScrolling}) => isScrolling && css`
      text-overflow: unset;
    `}
    
    ${({ onClick }) => onClick && css`
        cursor: pointer;
        
        &:hover {
            color: ${Colors.galBlack61};
        }
    `}

    @media (max-width: ${LayoutConst.screen.s}px){
      font-size: 17px;
      line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.sm}px){
      font-size: 14px;
      line-height: 18px;
    }
`

export const AudioTitleText = styled.span<{shouldScroll?: boolean, duration?: number}>`
  display: inline-block;
  transform: translateX(0);
  will-change: transform;
  white-space: nowrap;
  flex: 0 0 auto;
  min-width: max-content;
  width: max-content;
  flex-shrink: 0;
`

export const AudioTitleTrack = styled.div<{shouldScroll?: boolean}>`
  display: inline-flex;
  align-items: center;
  gap: 32px;
  width: max-content;
  flex: 0 0 auto;
  min-width: max-content;

  ${({shouldScroll}) => shouldScroll
          ? css`
            animation: ${audioTitleMarquee} var(--marquee-duration, 12s) linear infinite;
            animation-fill-mode: forwards;
            will-change: transform, opacity;
          `
          : css`
            animation: none;
          `
  };
`

export const IPhoneSwitcherWrapper = styled.div<{active?: boolean}>`
  border-radius: 12.667px;
  background: ${({active}) => active ? '#27AE60' : Colors.galBlack21};
  width: 32px;
  min-width: 32px;
  display: flex;
  height: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  justify-content: ${({active}) => active ? 'flex-end' : 'flex-start'};
  position: relative;

  div {
    transition: all 0.2s ease-in-out;
    position: absolute;
    top: 3px;
    left: ${({active}) => active ? 'calc(100% - 2.6px - 10px)' : '3px'};
    background: ${Colors.galBlack5};
    width: 10px;
    min-width: 10px;
    height: 10px;
    min-height: 10px;
    border-radius: 100%;
  }
`

export const IPhoneSwitcherLabel = styled.div`
  color: ${Colors.galBlack61};
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 
`